const apiURL = "https://mern-app-backend-nziz.onrender.com/api/v1/books";

export default apiURL;
